import { useEffect, useState } from 'react';
import { navItems, siteMeta } from '@/mocks/homeData';

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeMenu = () => setOpen(false);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? 'border-background-300/70 bg-background-50/95 backdrop-blur-md'
          : 'border-background-200 bg-background-50'
      }`}
    >
      <div className="mx-auto max-w-[1440px] px-4 md:px-8">
        {/* 报头层 */}
        <div className="flex items-center justify-between gap-4 pb-3 pt-4 md:pb-4 md:pt-6">
          <div className="flex items-center gap-3 md:gap-4">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-500 md:h-14 md:w-14">
              <i className="ri-flashlight-fill text-2xl text-background-50 md:text-3xl" aria-hidden="true"></i>
            </div>
            <div className="min-w-0">
              <h1 className="font-heading text-2xl font-black leading-none tracking-tight text-foreground-950 md:text-4xl">
                {siteMeta.name}
              </h1>
              <p className="mt-1 hidden font-label text-[11px] tracking-[0.28em] text-foreground-500 sm:block md:text-xs">
                {siteMeta.slogan}
              </p>
            </div>
          </div>

          <div className="hidden flex-col items-end gap-1 lg:flex">
            <span className="font-label text-xs tracking-wider text-foreground-500">{siteMeta.date}</span>
            <div className="flex items-center gap-2">
              <span className="rounded-full border border-primary-300 bg-primary-50 px-2.5 py-0.5 font-label text-[11px] font-bold text-primary-700">
                {siteMeta.issue}
              </span>
              <span className="font-label text-[11px] text-foreground-400">持续更新中</span>
            </div>
          </div>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            className="flex h-11 w-11 shrink-0 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-2-line text-xl'} aria-hidden="true"></i>
          </button>
        </div>

        {/* 主导航 */}
        <nav className="hidden items-center justify-between border-t border-background-200 py-2 lg:flex">
          <ul className="flex items-center gap-1">
            {navItems.map((item, idx) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  className={`block cursor-pointer rounded-md px-4 py-2 font-label text-sm font-medium transition-colors ${
                    idx === 0
                      ? 'bg-secondary-500 text-background-50'
                      : 'text-foreground-700 hover:bg-background-100 hover:text-primary-600'
                  }`}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          <div className="flex items-center gap-2">
            <a
              href="#subscribe"
              className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3 py-2 font-label text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-notification-3-line text-sm" aria-hidden="true"></i>
              订阅更新
            </a>
            <a
              href="#ranking"
              className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-xs font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line text-sm" aria-hidden="true"></i>
              热度榜
            </a>
          </div>
        </nav>
      </div>

      {/* 移动端菜单 */}
      {open && (
        <div className="animate-fade-in border-t border-background-200 bg-background-50 lg:hidden">
          <div className="mx-auto max-w-[1440px] px-4 py-3">
            <div className="mb-3 flex items-center justify-between rounded-md bg-background-100 px-3 py-2">
              <span className="font-label text-xs text-foreground-500">{siteMeta.date}</span>
              <span className="font-label text-[11px] font-bold text-primary-600">{siteMeta.issue}</span>
            </div>
            <ul className="grid grid-cols-2 gap-2">
              {navItems.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={closeMenu}
                    className="block cursor-pointer rounded-md border border-background-200 px-3 py-2.5 text-center font-label text-sm text-foreground-700"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
            <a
              href="#subscribe"
              onClick={closeMenu}
              className="mt-3 flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm font-bold text-background-50"
            >
              <i className="ri-notification-3-line text-base" aria-hidden="true"></i>
              订阅更新
            </a>
          </div>
        </div>
      )}
    </header>
  );
}